export default __webpack_public_path__ + "static/media/Blues.a6f9a70d.png";